<div class="content__inner">
    <header class="content__title">
        <h1 *ngIf="MODE === 'VIEW'">{{ "simcards.detail.view.title" | translate }}</h1>

        <div class="actions">
            <button (click)="back()" class="btn btn-secondary btn--icon-text"><i class="zmdi zmdi-arrow-back"></i> {{ "global.buttons.back" | translate }}</button>
        </div>
    </header>

    <!-- sim card -->
    <div class="card">
        <div class="card-body" *ngIf="simCard">
            <h3 class="card-body__title">{{ "simcards.props.simcardinfo" | translate }}</h3>
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "simcards.props.iccid" | translate }}</label>
                        <input name="iccid" type="text" class="form-control" [ngModel]="simCard.iccid" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "simcards.props.imei" | translate }}</label>
                        <input name="imei" type="text" class="form-control" [ngModel]="simCard.imei" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "simcards.props.state" | translate }}</label>
                        <input name="state" type="text" class="form-control" [ngModel]="simCard.state" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4" *ngIf="simCard.deactivationReason">
                    <div class="form-group">
                        <label>{{ "simcards.props.deactivationReason" | translate }}</label>
                        <textarea name="deactivationReason" class="form-control" [ngModel]="simCard.deactivationReason" readonly="readonly"></textarea>
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "simcards.props.firstActivation" | translate }}</label>
                        <input name="firstActivation" type="text" class="form-control" [ngModel]="simCard.firstActivation | date : UTCDATEFORMAT : '+0'" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "simcards.props.pendingSince" | translate }}</label>
                        <input name="pendingSince" type="text" class="form-control" [ngModel]="simCard.pendingSince | date : UTCDATEFORMAT : '+0'" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "simcards.props.scheduledSuspensionDate" | translate }}</label>
                        <input name="scheduledSuspensionDate" type="text" class="form-control" [ngModel]="simCard.scheduledSuspensionDate | date : UTCDATEFORMAT : '+0'" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "simcards.props.lastStateChangeDate" | translate }}</label>
                        <input name="lastStateChangeDate" type="text" class="form-control" [ngModel]="simCard.lastStateChangeDate | date : UTCDATEFORMAT : '+0'" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "simcards.props.lastPresenceDate" | translate }}</label>
                        <input name="lastPresenceDate" type="text" class="form-control" [ngModel]="simCard.lastPresenceDate | date : UTCDATEFORMAT : '+0'" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "simcards.props.currentTransferVolumeMb" | translate }}</label>
                        <input name="currentTransferVolumeMb" type="text" class="form-control" [ngModel]="simCard.currentTransferVolumeMb ?? '-'" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "simcards.props.billingCycleStart" | translate }}</label>
                        <input name="billingCycleStart" type="text" class="form-control" [ngModel]="simCard.billingCycle?.startDate ?? '-'" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "simcards.props.billingCycleEnd" | translate }}</label>
                        <input name="billingCycleEnd" type="text" class="form-control" [ngModel]="simCard.billingCycle?.endDate ?? '-'" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "simcards.props.created" | translate }}</label>
                        <input name="created" type="text" class="form-control" [ngModel]="simCard.created | date : UTCDATEFORMAT : '+0'" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "simcards.props.updated" | translate }}</label>
                        <input name="updated" type="text" class="form-control" [ngModel]="simCard.updated | date : UTCDATEFORMAT : '+0'" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- user -->
    <div class="card">
        <div class="card-body" *ngIf="simCard">
            <h3 class="card-body__title">{{ "simcards.props.user" | translate }}</h3>
            <div class="row" *ngIf="!simCard.user">
                <div class="col-md-12">-</div>
            </div>

            <div class="row" *ngIf="simCard.user">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "simcards.props.firstname" | translate }}</label>
                        <input name="userFirstname" type="text" class="form-control" [ngModel]="simCard.user.firstname" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "simcards.props.lastname" | translate }}</label>
                        <input name="userLastname" type="text" class="form-control" [ngModel]="simCard.user.lastname" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "simcards.props.email" | translate }}</label>
                        <input name="userEmail" type="text" class="form-control" [ngModel]="simCard.user.email" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- subscription -->
    <div class="card">
        <div class="card-body" *ngIf="simCard">
            <h3 class="card-body__title">{{ "simcards.props.subscription" | translate }}</h3>
            <div class="row" *ngIf="!simCard.subscription">
                <div class="col-md-12">-</div>
            </div>

            <div class="row" *ngIf="simCard.subscription">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "simcards.props.provider" | translate }}</label>
                        <input name="subscriptionProvider" type="text" class="form-control" [ngModel]="simCard.subscription.provider" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "simcards.props.productId" | translate }}</label>
                        <input name="subscriptionProductId" type="text" class="form-control" [ngModel]="simCard.subscription.productId" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "simcards.props.subscriptionStatus" | translate }}</label>
                        <input name="subscriptionStatus" type="text" class="form-control" [ngModel]="simCard.subscription.status" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "simcards.props.nextBillingDate" | translate }}</label>
                        <input name="subscriptionNextBillingDate" type="text" class="form-control" [ngModel]="simCard.subscription.nextBillingDate | date : UTCDATEFORMAT : '+0'" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "simcards.props.canceled" | translate }}</label>
                        <input name="subscriptionCanceled" type="text" class="form-control" [ngModel]="simCard.subscription.canceled | date : UTCDATEFORMAT : '+0'" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "simcards.props.inAppTransaction" | translate }}</label>
                        <div class="row">
                            <div class="col-12">
                                <div class="toggle-switch">
                                    <input type="checkbox" class="toggle-switch__checkbox" [ngModel]="simCard.subscription.inAppTransaction" id="inAppTransaction" name="inAppTransaction" [disabled]="true" />
                                    <i class="toggle-switch__helper"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- imei history -->
    <div class="card">
        <div class="card-body" *ngIf="simCard">
            <h3 class="card-body__title">{{ "simcards.props.imeiHistory" | translate }}</h3>
            <div class="row" *ngIf="!simCard.imeiHistory?.length">
                <div class="col-md-12">-</div>
            </div>

            <div class="table-responsive" *ngIf="simCard.imeiHistory?.length">
                <table class="table">
                    <thead>
                        <tr>
                            <th>{{ "simcards.props.imei" | translate }}</th>
                            <th>{{ "simcards.props.imeiHistoryDate" | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let entry of simCard.imeiHistory">
                            <td>{{ entry.imeiCode }}</td>
                            <td>{{ entry.date | date : UTCDATEFORMAT : "+0" }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
